export default {
    id: "logoper-partnership-2026",
    articleType: "release",
    slug: "sotrudnichestvo-s-logoper",
    date: "1 июля 2026",
    dateTime: "2026-07-01",
    modifiedTime: "2026-07-01",
    author: "Редакция «Светофор Логистика»",
    category: "Кейсы и партнёрства · 2026",
    contentType: "Кейс",
    title:
        "«Светофор Логистика» начала сотрудничество с логистическим оператором «Логопер»",
    sidebarTitle: "Сотрудничество с «Логопер»",
    seoTitle:
        "«Светофор Логистика» и «Логопер»: сотрудничество в мультимодальных перевозках",
    seoDescription:
        "К платформе «Светофор Логистика» присоединился оператор «Логопер», работающий с мультимодальными и контейнерными перевозками по России, СНГ и Азии.",
    image: "/img/news/sotrudnichestvo-s-logoper/cover.webp",
    imageAlt:
        "Сотрудничество логистического оператора «Логопер» и «Светофор Логистика»",
    gallery: [
        {
            src: "/img/news/sotrudnichestvo-s-logoper/photo-01.webp",

            thumbnail: "/img/news/sotrudnichestvo-s-logoper/photo-01-thumb.webp",
            alt:
                "Деловая встреча представителей «Логопер» и «Светофор Логистика»",
        },
        {
            src: "/img/news/sotrudnichestvo-s-logoper/photo-03.webp",

            thumbnail: "/img/news/sotrudnichestvo-s-logoper/photo-03-thumb.webp",
            alt: "Стенд логистического оператора «Логопер»",
        },
        {
            src: "/img/news/sotrudnichestvo-s-logoper/photo-04.webp",

            thumbnail: "/img/news/sotrudnichestvo-s-logoper/photo-04-thumb.webp",
            alt:
                "Материалы «Логопер» о контейнерной и железнодорожной логистике",
        },
        {
            src: "/img/news/sotrudnichestvo-s-logoper/photo-05.webp",

            thumbnail: "/img/news/sotrudnichestvo-s-logoper/photo-05-thumb.webp",
            alt: "Рабочая встреча с представителями «Логопер»",
        },
        {
            src: "/img/news/sotrudnichestvo-s-logoper/photo-06.webp",

            thumbnail: "/img/news/sotrudnichestvo-s-logoper/photo-06-thumb.webp",
            alt: "Фирменная лента «Логопер» на деловой встрече",
        },
    ],
    content: {
        subtitle:
            "На платформе появился один из крупнейших операторов мультимодальных и контейнерных перевозок России",
        lead: [
            "«Светофор Логистика» начала сотрудничество с ООО «Логопер» — крупным логистическим оператором, специализирующимся на мультимодальных и контейнерных перевозках.",
            "Партнёрство расширяет возможности пользователей платформы при работе со сложными маршрутами и крупными объёмами грузов.",
        ],
        sections: [
            {
                icon: "🚆",
                title: "О компании «Логопер»",
                paragraphs: [
                    "В управлении оператора находится более 100 000 контейнеров ДФЭ, собственные терминальные хабы и регулярные контейнерные поезда по России, СНГ и Азии.",
                ],
            },
            {
                icon: "📈",
                title: "Что это значит для пользователей",
                items: [
                    {
                        title: "Новые возможности",
                        text: "Сложные мультимодальные и интермодальные перевозки можно закрывать с участием оператора, способного работать с крупными объёмами грузов.",
                    },
                    {
                        title: "Масштабируемость",
                        text: "«Светофор Логистика» продолжает объединять сильных перевозчиков и операторов, чтобы решать логистические задачи разного масштаба в одном цифровом контуре.",
                    },
                    {
                        title: "Готовность к корпоративным требованиям",
                        text: "Подключение крупного оператора подтверждает готовность платформы к высоким требованиям безопасности, документооборота и корпоративных процессов.",
                    },
                ],
            },
            {
                icon: "🌐",
                title: "Развитие экосистемы",
                paragraphs: [
                    "Мы продолжаем развивать экосистему платформы и привлекать сильных игроков рынка, чтобы логистика пользователей становилась эффективнее и прозрачнее.",
                ],
            },
        ],
        galleryTitle: "Встречи с командой «Логопер»",
    },
};
